import NotFoundComponent from './NotFoundComponent.esm.js';

/** @private Guard cluase to narrow the AsyncRouteableComponent union type on getInitialProps */

function isAsyncComponent(Component) {
  return Component.getInitialProps !== undefined;
}
/** @private Guard cluase to narrow the AsyncRouteableComponent union type on load */

function isLoadableComponent(Component) {
  return Component.load !== undefined;
}
/** @private is given routes array have a 404 page?  */

function is404ComponentAvailable(routes) {
  return routes.find(function (route) {
    return ['**', '*', '', undefined].includes(route.path);
  }) || false;
}
/** @private Returns 404Component from given routes if component was not avaliable returns default 404component */

function get404Component(routes) {
  var match = is404ComponentAvailable(routes);
  return match ? match.component : NotFoundComponent;
}
/** @private Checks if 404Component is in routes, if it's not available add default 404 component */

function getAllRoutes(routes) {
  return is404ComponentAvailable(routes) ? routes : [].concat(routes, [{
    component: NotFoundComponent
  }]);
}
/** @private Checks if given string ends with ".js" */

function isJS(str) {
  return str.endsWith('.js');
}
/** @private Checks if given transition type is instant */

function isInstantTransition(transition) {
  return transition === "instant";
}

export { get404Component, getAllRoutes, is404ComponentAvailable, isAsyncComponent, isInstantTransition, isJS, isLoadableComponent };
//# sourceMappingURL=utils.esm.js.map
